import { defineMessages } from 'react-intl';

export const messages: Record<
	string,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	title: {
		id: 'conversation-assistant-message-actions.controllers.jira-create-sprint.title',
		defaultMessage: 'Create sprint',
		description: 'Heading shown at the top of the create sprint action card in Rovo chat.',
	},
	nameLabel: {
		id: 'conversation-assistant-message-actions.controllers.jira-create-sprint.nameLabel',
		defaultMessage: 'Name',
		description: 'Label for the sprint name detail row in the create sprint action card.',
	},
	goalLabel: {
		id: 'conversation-assistant-message-actions.controllers.jira-create-sprint.goalLabel',
		defaultMessage: 'Goal',
		description: 'Label for the sprint goal detail row in the create sprint action card.',
	},
	startDateLabel: {
		id: 'conversation-assistant-message-actions.controllers.jira-create-sprint.startDateLabel',
		defaultMessage: 'Start date',
		description: 'Label for the start date detail row in the create sprint action card.',
	},
	endDateLabel: {
		id: 'conversation-assistant-message-actions.controllers.jira-create-sprint.endDateLabel',
		defaultMessage: 'End date',
		description: 'Label for the end date detail row in the create sprint action card.',
	},
	confirmButton: {
		id: 'conversation-assistant-message-actions.controllers.jira-create-sprint.confirmButton',
		defaultMessage: 'Confirm',
		description:
			'Label for the confirm button in the create sprint action card that submits the action.',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.controllers.jira-create-sprint.cancelButton',
		defaultMessage: 'Cancel',
		description:
			'Label for the cancel button in the create sprint action card that dismisses the action.',
	},
});
